import {Injectable} from '@angular/core';
import {AnnouncementModalComponent} from '../components/announcement-modal/announcement.modal.component';
import {IAnnouncementsHttpService} from './announcements-http.service.interface';
import {AnnouncementModel} from '../models/announcement-model';
import {ModalDynamicV3Service} from '../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';


@Injectable()
export class AnnouncementsService {


    constructor(
        private modalDynamicV3Service: ModalDynamicV3Service,
        private announcementsHttpService: IAnnouncementsHttpService
    ) {
    }


    /**
     * This method is responsible for loading and processing announcements.
     * It fetches the announcements from the `announcementsHttpService`,
     * opens a modal for each announcement, waits for the modal to close,
     * and then confirms the announcement through the `announcementsHttpService`.
     *
     * @returns {Promise<void>} A Promise that resolves when all announcements have been processed.
     */
    public async processAnnouncements(): Promise<void> {


        // Fetch the announcements from the `announcementsHttpService`
        const announcements: AnnouncementModel[] = await this.announcementsHttpService.getAnnouncements();

        // console.log('processAnnouncements', announcements);

        // Process each announcement
        for (const announcement of announcements) {

            // Open a modal for the current announcement
            const modalRef = this.modalDynamicV3Service.open(AnnouncementModalComponent, {model: announcement});

            // Wait for the modal to close and capture the result, the result is fired only if the confirmation button is clicked
            const result = await this.firstValueFrom(modalRef);

            if (result) {
                // Confirm the announcement through the `announcementsHttpService`
                try {
                    await this.announcementsHttpService.confirmAnnouncements([announcement]);
                } catch (e) {
                    console.error('Error confirming announcement', e);
                }
            }

        }
    }


    async firstValueFrom(modalRef: IModalDialogV3) {
        return new Promise((resolve, reject) => {
            modalRef.subscribe((result) => {
                // when we get the first value from the modalRef, we finish the "new promise" via resolve
                resolve(result);
            });
        });
    }
}
